import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import { toast } from 'react-toastify';
import '../components/authSlide.css';

export default function Login(){
  const [loginEmail,setLoginEmail]=useState('');
  const [loginPassword,setLoginPassword]=useState('');
  const [regName,setRegName]=useState('');
  const [regUsername,setRegUsername]=useState('');
  const [regRole,setRegRole]=useState('Student');
  const [regPassword,setRegPassword]=useState('');
  const [error,setError]=useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) =>{
    e.preventDefault();
    try{
      const user = await login(loginEmail,loginPassword);
      // Role-based redirect: send users to a role-appropriate landing page
      if (user?.role === 'Admin') {
        navigate('/admin');
      } else if (user?.role === 'Security') {
        navigate('/security');
      } else if (user?.role === 'Maintenance') {
        navigate('/maintenance');
      } else if (user?.role === 'Manager' || user?.role === 'Clerk') {
        navigate('/dashboard');
      } else {
        navigate('/events');
      }
    }catch(err){
      setError(err.userMessage || err.response?.data?.message || 'Login failed');
      toast.error(err.userMessage || 'Login failed');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try{
      // Backend requires an email field. Use username as email if it looks like one,
      // otherwise synthesize a placeholder domain so registration succeeds on the API.
  const emailToSend = regUsername && regUsername.includes('@') ? regUsername : `${regUsername || 'user'}@noemail.local`;
  await api.post('/auth/register', { name: regName, email: emailToSend, password: regPassword, role: regRole, username: regUsername });
  toast.success('Registration successful — logging you in');
  // auto-login after register using the email we sent to the backend
  const user = await login(emailToSend, regPassword);
      if (user?.role === 'Admin') {
        navigate('/admin');
      } else if (user?.role === 'Security') {
        navigate('/security');
      } else if (user?.role === 'Maintenance') {
        navigate('/maintenance');
      } else if (user?.role === 'Manager' || user?.role === 'Clerk') {
        navigate('/dashboard');
      } else {
        navigate('/events');
      }
    }catch(err){
      const msg = err.response?.data?.message || err.userMessage || 'Registration failed';
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{background:'linear-gradient(to bottom, #0f0c29, #302b63, #24243e)', padding:'40px'}}>
      <div className="auth-slide-main auth-slide-inner">
        <input type="checkbox" id="chk" aria-hidden="true" />

        <div className="signup">
          <form onSubmit={handleRegister} aria-label="Sign up form">
            <label className="auth-label" htmlFor="chk">Sign up</label>
            <input className="auth-input" placeholder="Username" value={regUsername} onChange={e=>setRegUsername(e.target.value)} required />
            <input className="auth-input" placeholder="Full name" value={regName} onChange={e=>setRegName(e.target.value)} required />
            <select className="auth-input" value={regRole} onChange={e=>setRegRole(e.target.value)} aria-label="role">
              <option value="Student">Student</option>
              <option value="Manager">Manager</option>
            </select>
            <input className="auth-input" type="password" placeholder="Password" value={regPassword} onChange={e=>setRegPassword(e.target.value)} required />
            <button className="auth-button" type="submit">Sign up</button>
            <div className="auth-note auth-small">Already have an account? <label htmlFor="chk" style={{color:'#fff',cursor:'pointer'}}>Login</label></div>
          </form>
        </div>

        <div className="login">
          <form onSubmit={handleLogin} aria-label="Login form">
            <label className="auth-label" htmlFor="chk">Login</label>
            {error && <div style={{color:'#b91c1c', textAlign:'center'}}>{error}</div>}
            <input className="auth-input" type="email" placeholder="Email" value={loginEmail} onChange={e=>setLoginEmail(e.target.value)} required />
            <input className="auth-input" type="password" placeholder="Password" value={loginPassword} onChange={e=>setLoginPassword(e.target.value)} required />
            <button className="auth-button" type="submit">Login</button>
            <div className="auth-note auth-small">New here? <label htmlFor="chk" style={{color: 'var(--accent)', cursor:'pointer'}}>Create account</label></div>
          </form>
        </div>
      </div>
    </div>
  );
}
